<template>
  <div class="home" style='font-size: 11pt;'>
    <transition name="fade">
      <LoadingVue v-if="isLoading"></LoadingVue>
    </transition>
   <!--  <header class='p-3 text-center vertical-align-top' style="background-color: #0080FF;">
      <span style="color:white; font-size: 30pt; font-family: Avenir; font-weight: bold;">MCCP: <I>M</I>etabolite-Mediated <I>C</I>ell-Cell <I>C</I>ommunication <I>P</I>ortal</span>
    </header> -->
    <div style="background: linear-gradient(to bottom, #CCE5FF, #FFFFFF);">
      <div class='container'>
        <img 
          alt="model logo" 
          width="65%" 
          class="mx-auto d-block"
          :src="require('@/assets/mccp_home.svg')"
        >
        <br>
        </div>
    </div>
    <div class='h-100 w-100 container'>
      <h5 style="text-align: center; font-family: Avenir;"><i><b>A suite of web services for investigating <u>metabolite-mediated cell communication (mCCC)</u> using scRNA-seq data</b></i></h5>
      <div class="d-flex justify-content-center">
        <!-- <b-button 
          size="sm"
          @click="keyJump('chatbot')" 
          class="btn-custom_chatbot"
        >
          <h4 class="mb-0">🤖 <b>Agentic ChatBot</b></h4>
        </b-button> -->
        <a href="https://rc-cbp.tch.harvard.edu/agent/chatbot/" target="_blank"><h4 class="mb-0">🤖 <b>Agentic ChatBot</b></h4></a>
      </div>
      <hr>  
<!--       <div
      @mouseover='btnclass = true'
      @mouseleave='btnclass = false'
      >            
        <b-input-group 
        size='md' 
        >
          <b-button
            size='md'
            variant="secondary"
            style="font-family: Avenir;"
          >Keyword</b-button>
          <b-form-input
          id='hpageInput'
          placeholder="search by metabolite name, sensor name, enzyme name, etc."
          v-model='inputKeyword'
          size='md'
          ></b-form-input>
          <b-input-group-append>
            <b-button
              size='md'
              :class="btnclass === true ? 'btn-custom2' : 'btn-custom1'"
              @click="keyJump('database')"
            >Search MSDB</b-button>
            </b-input-group-append>
        </b-input-group>
      </div> -->
      
      <div>
        <b-row>
          <b-col cols='3'>
            <b-card 
              header-tag="header" 
              footer-tag="footer" 
              border-variant="dark" 
              :header-bg-variant="currentVariant1" 
              @mouseover="currentVariant1 = 'highlightcustom'" 
              @mouseleave="currentVariant1 = 'homecustom'"
              class="h-100 w-100"
            >
              <template #header>
                <h5 class="mb-0 text-center" :style="{ color: currentVariant1 === 'homecustom' ? 'black' : 'black' }">
                  <b-icon icon="view-stacked" :variant="currentVariant1 === 'homecustom' ? 'dark' : 'dark'"></b-icon> The mCCC Landscape
                </h5>
              </template>
              <span>
                <b>MCCE</b>: Explore 812,533 mCCC events among 628 cell types of 67 tissue types, 248 anatomic sites, and 99 disease states.
              </span>
              <b-button 
                size="md" 
                pill
                @click="keyJump('ccc')" 
                :class="currentVariant1 === 'homecustom' ? 'btn-custom0' : 'btn-custom2'">
                Go MCCE
              </b-button>
            </b-card>
          </b-col>
          <b-col cols='3'>
            <b-card 
              header-tag="header" 
              footer-tag="footer" 
              border-variant="dark" 
              :footer-bg-variant='currentVariant4'
              @mouseover="currentVariant4 = 'highlightcustom'" 
              @mouseleave="currentVariant4 = 'homecustom'"
              class="h-100 w-100"
            >
              <template #footer>
                <h5 class="mb-0 text-center" :style="{ color: currentVariant4 === 'homecustom' ? 'black' : 'black' }">
                  <b-icon icon="file-earmark-diff" :variant="currentVariant4 === 'homecustom' ? 'dark' : 'dark'"></b-icon> Disease-Associated mCCC
                </h5>
              </template>
              <span>
                <b>MCCD</b>: Investigate 213,145 disease-associated mCCC by 258 differential analyses between diseases and normal states.
              </span>
              <b-button size="md" pill @click="keyJump('mccd')"
              :class="currentVariant4 === 'homecustom' ? 'btn-custom0' : 'btn-custom2'">Go MCCD</b-button>
            </b-card>
          </b-col>
          <b-col cols='3'>
            <b-card 
              header-tag="header" 
              footer-tag="footer" 
              border-variant="dark" 
              @mouseover="currentVariant2 = 'highlightcustom'" 
              @mouseleave="currentVariant2 = 'homecustom'"
              :header-bg-variant="currentVariant2" 
              class="h-100 w-100"
            >
              <template #header>
                <h5 class="mb-0 text-center" :style="{ color: currentVariant2 === 'homecustom' ? 'black' : 'black' }">
                  <b-icon icon="clipboard-data" :variant="currentVariant2 === 'homecustom' ? 'dark' : 'dark'"></b-icon> Tissue Specific mCCC
                </h5>
              </template>
              <span>
                <b>MCCT</b>: Investigate mCCC specificity of metabolite-sensor pairs across biological systems, tissue types, and anatomic sites using the mCCC landscape.
              </span>
              <b-button size="md" pill @click="keyJump('mcct')" :class="currentVariant2 === 'homecustom' ? 'btn-custom0' : 'btn-custom2'">Go MCCT</b-button>
            </b-card>
          </b-col>
          <b-col>
            <b-card 
              header-tag="header" 
              footer-tag="footer" 
              border-variant="dark" 
              :footer-bg-variant="currentVariant3" 
              @mouseover="currentVariant3 = 'highlightcustom'" 
              @mouseleave="currentVariant3 = 'homecustom'"
              class="h-100 w-100"
            >
              <template #footer>
                <h5 class="mb-0 text-center" :style="{ color: currentVariant3 === 'homecustom' ? 'black' : 'black' }">
                  <b-icon icon="gear" :variant="currentVariant3 === 'homecustom' ? 'dark' : 'dark'"></b-icon>
                  Metabolite-Sensor Pair
                </h5>
              </template>
              <span>
                <b>MSDB</b>: Browse curated metabolite-sensor pairs collected from literatures and public database.
              </span>
              <b-button size="md" pill @click="keyJump('database_jump')" :class="currentVariant3 === 'homecustom' ? 'btn-custom0' : 'btn-custom2'">Go MSDB</b-button>
            </b-card>
            <!-- <b-card 
              header-tag="header" 
              footer-tag="footer" 
              border-variant="dark" 
              :footer-bg-variant="currentVariant3" 
              @mouseover="currentVariant3 = 'highlightcustom'" 
              @mouseleave="currentVariant3 = 'homecustom'"
              class="h-100 w-100"
            >
              <template #footer>
                <h5 class="mb-0 text-center" :style="{ color: currentVariant3 === 'homecustom' ? 'black' : 'black' }">
                  <b-icon icon="gear" :variant="currentVariant3 === 'homecustom' ? 'dark' : 'dark'"></b-icon>
                  mCCC Integration
                </h5>
              </template>
              <span>
                <b>MCCI</b>: Integrate mCCC profile between cell types across biological system, tissue types, and anatomic sites.
              </span>
              <b-button size="md" pill @click="keyJump('mcci')" :class="currentVariant3 === 'homecustom' ? 'btn-custom0' : 'btn-custom2'">Go MCCI</b-button>
            </b-card> -->
            <!-- <b-card 
              header-tag="header" 
              footer-tag="footer" 
              border-variant="dark" 
              :footer-bg-variant="currentVariant3" 
              @mouseover="currentVariant3 = 'highlightcustom'" 
              @mouseleave="currentVariant3 = 'homecustom'"
              class="h-100 w-100"
            >
              <template #footer>
                <h5 class="mb-0 text-center" :style="{ color: currentVariant3 === 'homecustom' ? 'black' : 'black' }">
                  <b-icon icon="gear" :variant="currentVariant3 === 'homecustom' ? 'dark' : 'dark'"></b-icon>
                  Process My Data
                </h5>
              </template>
              <span>
                <b>MCCR</b>: mCCC network inference and differential mCCC analysis using in-house scRNA-seq data.
              </span>
              <b-button size="md" pill @click="keyJump('mccb')" :class="currentVariant3 === 'homecustom' ? 'btn-custom0' : 'btn-custom2'">GoRun</b-button>
            </b-card> -->
          </b-col>
        </b-row>
      </div>
    </div>
    <br>
    <div class='container'>
      <b-button 
        size="md"
        class='btn-custom0 w-100'
        @click="tableshow = !tableshow"
      >
        <h5 class='my-0'><b-icon icon="table" variant="dark"></b-icon> Datasets for mCCC Landscape</h5>
      </b-button>
      <div v-if='tableshow === true'>
        <DataBrowser></DataBrowser>
      </div>
    </div>
    <div class='container'>
      <b-card header-bg-variant='light' header-text-variant='dark' class='h-100' border-variant='light'>
        <template #header><h5 class='my-0'><b-icon icon="cloud-upload" variant="dark"></b-icon> Provide feedback</h5></template>
        <span>We invite users to provide any feedback, suggestions, or report issues via a <a href='https://forms.cloud.microsoft/r/2pFRNP0HiG' target='_blank'>MicroSoft form</a>. Please consider to leave your email address so that we can better communicate with you, especially when you report issues or errors. Thank you.</span>
      </b-card>
      <b-card header-bg-variant='light' header-text-variant='dark' class='h-100' border-variant='light'>
        <template #header><h5 class='my-0'><b-icon icon="paperclip" variant="dark"></b-icon> Cite us</h5></template>
        <!-- <span><b>Please cite us if you found this site is useful to your work:</b></span> -->
        <li>
          Rongbin Zheng, Yang Zhang, Tadataka Tsuji, Xinlei Gao, Farnaz Shamsi, Allon Wagner, Nir Yosef, Kui Cui, Hong Chen, Michael A. Kiebish, Juan J. Aristizabal-Henao, Niven R. Narain, Lili Zhang, Yu-Hua Tseng, Kaifu Chen. MEBOCOST maps metabolite-mediated intercellular communications using single-cell RNA-seq. Nucleic Acids Research. https://doi.org/10.1093/nar/gkaf569
        </li>
<!--         <li>
          Rongbin Zheng, Yang Zhang, Tadataka Tsuji, Xinlei Gao, Allon Wagner, Nir Yosef, Hong Chen, Lili Zhang, Yu-Hua Tseng, Kaifu Chen, MEBOCOST: Metabolite-mediated Cell Communication Modeling by Single Cell Transcriptome, bioRxiv 2022.05.30.494067; doi: https://doi.org/10.1101/2022.05.30.494067
        </li> -->
      </b-card>
    </div>
    <div class='container'>
      <b-row>
        <!-- <b-col cols='6'> -->
          <b-card header-bg-variant='light' header-text-variant='dark' class='h-100'>
            <template #header><h5 class='my-0'><b-icon icon="link" variant="dark"></b-icon> Related Resource </h5></template>
            <ul>
              <li><span>MEBOCOST: Python-based algorithm to predict mCCC using scRNA-seq data </span>
                <a href="https://github.com/kaifuchenlab/MEBOCOST" style="text-decoration: none" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>Human Metabolome Database: <I>metabolite basics, reactions, enzymes </I> </span>
                <a href="https://hmdb.ca/" style="text-decoration: none" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>Transporter Classification Database: <I>metabolite transporter </I> </span>
                <a href="https://tcdb.org/" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>Recon2: <I>metabolic reaction </I> </span>
                <a href="https://www.ebi.ac.uk/biomodels/MODEL1603150001" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>KEGG: <I>compound and pathway </I></span>
                <a href="https://www.genome.jp/kegg/" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>Uniprot: <I>protein annotation and cellular location </I> </span>
                <a href="https://www.uniprot.org/" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>Nuclear Receptor Signaling Atlas (NURSA): <I>nuclear receptor </I> </span>
                <a href="https://dknet.org/data/source/nif-0000-03208-6/search?q=%2A&l=&facet[]=Type%3ANuclear%20Receptor" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>GPCRdb: <I>metabolite receptor </I></span>
                <a href="https://gpcrdb.org" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>DISCO: <I>a large scale scRNA-seq data </I> </span>
                <a href="https://www.immunesinglecell.org/" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li> 
              <li><span>CellxGene: <I>a large scale scRNA-seq data </I> </span>
                <a href="https://cellxgene.cziscience.com/datasets" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>
              <li><span>TISCH: <I>tumor immunology focused scRNA-seq database </I> </span>
                <a href="http://tisch.comp-genomics.org" style="text-decoration: none;" target="_blank"><b-icon icon="link" variant="primary"></b-icon></a>
              </li>   
              </ul>        
          </b-card>
<!--         </b-col>
        <b-col cols='6'>
          <b-card header-bg-variant='light' header-text-variant='dark' class='h-100'>
            <template #header><h5 class='my-0'><b-icon icon="newspaper" variant="dark"></b-icon> News</h5></template>
            <ul>
              <li><span>07/2025 - Improved Tissue Specificity functions.</span></li>
              <li><span>06/15/2025 - The MCCP fomally is released through conferences, such as CADA annual meeting.</span></li>
              <li><span>06/2025 - Improved interface and visualization.</span></li>
              <li><span>05/2025 - Adding 258 Disease vs normal comparisons.</span></li>
              <li><span>04/2025 - Expanded datasets to cover diverse tissue types.</span></li>
              <li><span>03/2025 - Ready interface for searching, integration, and visualization.</span></li>
            </ul>
          </b-card>

        </b-col> -->
      </b-row>
    </div>
    <br/><br/><br/><br/>
  </div>
</template>

<script>
// @ is an alias to /src
import Bus from '../api/bus.ts'

import LoadingVue from '@/components/LoadingVue.vue'
import DataBrowser from '@/components/DataBrowser.vue'

export default {
  name: 'HomeView',
  components: {
    LoadingVue,
    DataBrowser,
  },
  data () {
    return {
      isLoading: false,
      inputKeyword: '',
      currentVariant1: 'homecustom',
      currentVariant2: 'homecustom',
      currentVariant3: 'homecustom',
      currentVariant4: 'homecustom',
      btnclass: false,
      tableshow: true,
    }
  },
  methods: {
    keyJump (b) {
      // alert(this.selected_sp)
      if (b === 'mccb') {
        this.$router.push({
            path: '/webserverpage',
          })
      }else if (b === 'ccc') {
        this.$router.push({
            path: '/ccc',
          })
      }else if (b === 'browser') {
        this.$router.push({
            path: '/browser',
          })
      }else if (b === 'mcct') {
        this.$router.push({
            path: '/WebMCCTpage',
          })
      }else if (b === 'mccd') {
        this.$router.push({
            path: '/Webdiffmcccpage',
          })
      }else if (b === 'database_jump') {
        this.$router.push({
            path: '/database',
          })
      }else if (b === 'chatbot') {
        this.$router.push({
            path: '/ChatBot',
          })
      }else if (b === 'mcci') {
        this.$router.push({
            path: '/OwnIntegration',
          })
      }else if (b === 'database') {
        if (this.inputKeyword !== ''){
          sessionStorage.setItem('fromPush', 'true');
          this.$router.push({
            path: '/database',
            query: {
              keyword_content: this.inputKeyword
            }
          })
        }
        // this.$router.push({
        //     path: '/database',
        //   })
      }else{
        console.log('error')
      }
    },
    // popShow for upload new
    popShow (item) {
      Bus.$emit('upload_item', item)
      this.$bvModal.show('upload_new_pop')
    }
  }
}
</script>

<style>
  
span {
  text-align: justify
}
.bg-homecustom {
    background-color: #66B2FF !important;
  }
.bg-highlightcustom {
    background-color: #FFCC99 !important;
  }
.btn-custom_chatbot {
    background-color: white !important;
    border-color: white !important;
    color: black !important;
  } 
.btn-custom0 {
    background-color: white !important;
    border-color: black !important;
    color: black !important;
  }
.btn-custom1 {
    background-color: #66B2FF !important;
    border-color: #66B2FF !important;
    color: black !important;
  }
.btn-custom2 {
    background-color: #FFCC99 !important;
    border-color: #FFCC99 !important;
    color: black !important;
  }

</style>
